import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";

interface DataLayerItem {
    item_id: string;
    item_name: string;
    item_brand: string;
    price?: number;
    quantity: number | null;
    [key: string]: any;
}

const generateMultipleItemArray = (products: CartLineModel[]) => {
    const itemArr: DataLayerItem[] = [];
    products.forEach(product => {
        const obj: DataLayerItem = {
            item_id: product.erpNumber ?? "",
            item_name: product.altText,
            item_brand: product.brand?.name || "",
            price: product.pricing?.unitNetPrice,
            quantity: product.qtyOrdered,
            item_category: product.properties.categories || "",
            item_list_id: product.id || "",
            item_list_name: product.properties.categories || "",
        };
        const categoriesArr: string[] =
            product && product.properties && product.properties.categories
                ? product.properties.categories.split(",")
                : [];
        let i = 1;
        if (categoriesArr[categoriesArr.length - 1] === "") {
            categoriesArr.pop();
        }
        if (categoriesArr.length !== 0) {
            const uniqueItems: Record<string, boolean> = {};
            for (const item of categoriesArr) {
                if (!uniqueItems[item]) {
                    if (i === 1) {
                        obj.item_category = item;
                        uniqueItems[item] = true;
                    } else {
                        obj[`item_category${i}`] = item;
                        uniqueItems[item] = true;
                    }
                    i++;
                }
            }
        }
        itemArr.push(obj);
    });
    return itemArr;
};

const generateItemArrayForOrderDetailPage = (products: OrderLineModel[]) => {
    const itemArr: DataLayerItem[] = [];
    products.forEach(product => {
        // console.log("product", product);
        const obj: DataLayerItem = {
            item_id: product?.productErpNumber ?? "",
            item_name: product.altText,
            item_brand: product.brand?.name || "",
            price: product.unitNetPrice,
            quantity: product.qtyOrdered,
            location: "order_details_page",
            item_category: product.properties.categories || product.shortDescription || "",
            item_list_id: product?.productId,
            item_list_name: product.properties.categories || product.shortDescription || "",
        };
        itemArr.push(obj);
    });
    return itemArr;
};

const generateDataLayer: any = (wishlistItems: DataLayerItem[] | null) => {
    const dataLayer = (window as any).dataLayer || [];
    if (dataLayer) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_wishlist",
            ecommerce: {
                wishlistItems,
            },
        });
    }
    // console.log("whishlist3 dataLayer", dataLayer);
    // return dataLayer;
};

export const addAllToWishlistDataLayer = (productArray: CartLineModel[] | null | undefined) => {
    if (productArray) {
        const wishlistItems = generateMultipleItemArray(productArray);
        return generateDataLayer(wishlistItems);
    }
};

export const addAllToWishListDataLayerOrderPage = (orderArray: OrderLineModel[] | null | undefined) => {
    if (orderArray) {
        const wishlistItems = generateItemArrayForOrderDetailPage(orderArray);
        return generateDataLayer(wishlistItems);
    }
};
